import axios from 'axios'
import VueCookies from 'vue-cookies'
import DefaultUtils from '@/utils/default.utils'

export default class ApiService {

    static mapUrl(url, port = 5050) {
        if(!url)
            return

        if (!url.startsWith('/')) {
            url = `/${url}` 
        }

        //let prodUrl = `${window.location.protocol}//${window.location.host}/selfinvest`
        let prodUrl = `${window.location.protocol}//${window.location.host}`
        let devUrl = `http://localhost:${port}`

        // fetch('https://ipapi.co/json/')
        // .then(function(response) {
        //     return response.json()
        // })
        // .then(function(data) {
        //     console.log(data)
        // })

        let apiUrl = ''

  
        if (process.env.NODE_ENV == "production") {
            apiUrl = prodUrl
        } else {
            apiUrl = devUrl
        }
        url = apiUrl + url

        // console.log("prodUrl",prodUrl)
        // console.log("url",prodUrl)

        return url
    }

    static getAccessToken() {
        return VueCookies.get("access_token-self")
    }

    static async chamaApi(api, dataObject = null) {
        let access_token = this.getAccessToken()

        //Content-Length

        let requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                // 'Cache-Control': 'no-cache'
            },
        }

        if (access_token) {
            requestOptions = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                    // 'Cache-Control': 'no-cache'
                },
            }
        }

        


        if (dataObject) { // post 

            try {
                requestOptions.method = 'POST'
                requestOptions.body = dataObject

                const response = await axios.post(this.mapUrl(api), dataObject, requestOptions)

                return response.data

            } catch (ex) {
                let message = ""

                if (ex.response) {
                    message = ex.response
                    if(ex.response.data){
                        message = ex.response.data.Mensagem
                    }
                } else if (ex.request) {
                    message = ex.request
                } else {
                    message = ex.message
                }
                //console.log(ex)
                throw {
                    Sucesso: false,
                    Mensagem: message,
                    Descricao : ex
                }
            }

        } else {// get
            try {

                requestOptions.method = 'GET'

                const response_1 = await axios.get(this.mapUrl(api), requestOptions)

    
                const dataJavaScript = new Date()               
                dataJavaScript.setMinutes(dataJavaScript.getMinutes() + 15)

                console.log(dataJavaScript)
              
                return response_1.data

            } catch (ex) {
                let ex_descrition = {}

                if (ex.response) {
                    ex_descrition = ex.response
                } else if (ex.request) {
                    ex_descrition = ex.request
                } else {
                    ex_descrition = ex.message
                }
                // console.log("apiService",ex)
                // console.log("api",api)
                throw {
                    Sucesso: false,
                    Mensagem: ex.message,
                    Descricao : ex,
                }
            }
        }
    }

    static async chamaApiv2(api, dataObject = null) {
        let access_token = this.getAccessToken()

        //Content-Length

        let requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                // 'Cache-Control': 'no-cache'
            },
        }

        if (access_token) {
            requestOptions = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                    // 'Cache-Control': 'no-cache'
                },
            }
        }

        


        if (dataObject) { // post 

            try {
                requestOptions.method = 'POST'
                requestOptions.body = dataObject

                const response = await axios.post(this.mapUrl(api,5050), dataObject, requestOptions)

                return response.data

            } catch (ex) {
                let message = ""

                if (ex.response) {
                    message = ex.response
                    if(ex.response.data){
                        message = ex.response.data.Mensagem
                    }
                } else if (ex.request) {
                    message = ex.request
                } else {
                    message = ex.message
                }
                //console.log(ex)
                throw {
                    Sucesso: false,
                    Mensagem: message,
                    Descricao : ex
                }
            }

        } else {// get
            try {

                requestOptions.method = 'GET'

                const response_1 = await axios.get(this.mapUrl(api,5050), requestOptions)

    
                const dataJavaScript = new Date()               
                dataJavaScript.setMinutes(dataJavaScript.getMinutes() + 15)

                console.log(dataJavaScript)
              
                return response_1.data

            } catch (ex) {
                let ex_descrition = {}

                if (ex.response) {
                    ex_descrition = ex.response
                } else if (ex.request) {
                    ex_descrition = ex.request
                } else {
                    ex_descrition = ex.message
                }
                // console.log("apiService",ex)
                // console.log("api",api)
                throw {
                    Sucesso: false,
                    Mensagem: ex.message,
                    Descricao : ex,
                }
            }
        }
    }

    static interceptorsResponse() {
        return new Promise((resolve, reject) => {
            axios.interceptors.response.use((response) => {
                resolve(response)
            }, (err) => {
                reject(err)
            })
        })
    }

    static async chamaApi2(api, dataObject = null) {
        let requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                // 'Cache-Control' : 'no-cache'
            },
        }

        if (dataObject != null) { // post 

            try {
                requestOptions.method = 'POST'
                requestOptions.body = dataObject

                const response = await axios.post(api, dataObject, requestOptions)

                return response.data

            } catch (ex) {
                let ex_descrition = {}

                if (ex.response) {
                    ex_descrition = ex.response
                } else if (ex.request) {
                    ex_descrition = ex.request
                } else {
                    ex_descrition = ex.message
                }

                return {
                    Sucesso: false,
                    Mensagem: 'Erro no servidor',
                    Descricao: ex_descrition
                }
            }

        } else {// get
            try {

                requestOptions.method = 'GET'

                const response_1 = await axios.get(api, requestOptions)

                return response_1.data

            } catch (ex) {
                let ex_descrition = {}

                if (ex.response) {
                    ex_descrition = ex.response
                } else if (ex.request) {
                    ex_descrition = ex.request
                } else {
                    ex_descrition = ex.message
                }

                return {
                    Sucesso: false,
                    Mensagem: 'Erro no servidor',
                    Descricao: ex_descrition
                }
            }
        }
    }

    static async getCep(cep){
        try{
            cep = DefaultUtils.somenteNumeber(cep)

            const url = `https://viacep.com.br/ws/${cep}/json/`

            const response = await axios.get(url)

            return response.data

        }catch(ex){
            let ex_descrition = {}

                if (ex.response) {
                    ex_descrition = ex.response
                } else if (ex.request) {
                    ex_descrition = ex.request
                } else {
                    ex_descrition = ex.message
                }

                return {
                    Sucesso: false,
                    Mensagem: 'Erro no servidor',
                    Descricao: ex_descrition
                }
        }
    }
}
